import cloneDeep from 'lodash/cloneDeep';
import type { PiniaPluginContext } from 'pinia';

export const piniaStoreReset = ({ store }: PiniaPluginContext) => {
  const initialState = cloneDeep(store.$state);

  store.$reset = () => {
    try {
      store.$patch(cloneDeep(initialState));
    } catch (error) {
      throw error;
    }
  };
};
